export default __webpack_public_path__ + "static/media/sunsetcar.6355223a.jpg";